import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { ThemeProps, RTLProps } from "@/shared/prop-types/ReducerProps";
import CheckboxField from "@/shared/components/form/CheckboxField";
import {
  Modal,
  ModalBody,
  ModalHeader,
  Button,
  ButtonToolbar,
  Row,
  Col,
} from "reactstrap";
import { Form } from "react-final-form";
import formValidation from "@/shared/validation/program-engagement";
import axios from "axios";
import { sendFlashMessage } from "@/shared/components/flash";
import { getProgramAction } from "@/redux/actions/programActions";
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import TooltipPopup from '@/shared/components/form/TooltipPopup';
import { BUDGET_INFO_POPUP_DATA } from './BudgetCascadingPopupData';
import "./style.scss"

const EngagementModal = ({
  dispatch,
  data,
  isOpen,
  toggle,
  theme,
  rtl,
}) => {
  const [loading, setLoading] = useState(false);
  const [openTooltipPopup, setTooltipPopup] = useState(null);

  const handleCloseTooltipPopup = () => {
    setTooltipPopup(null);
};

const handleOpenTooltipPopup = (title) => {
    setTooltipPopup(title);
};

  const onSubmitForm = async (values) => {
    setLoading(true);
    data = { ...data, ...values };
    // console.log(values)
    // console.log(data);return;
    // alert(JSON.stringify(data))
    try {
      const response = await axios.put(
        `/organization/${data.organization_id}/program/${data.id}`,
        data
      );

      setLoading(false);
      // setData( data )
      if (response.status === 200) {
        dispatch(
          sendFlashMessage("Program has been updated", "alert-success", "top")
        );
        dispatch(getProgramAction(data.organization_id, data.id));
      }
    } catch (e) {
      setLoading(false);
      dispatch(
        sendFlashMessage("Program could not be updated", "alert-danger", "top")
      );
      throw new Error(`API error:${e?.message}`);
    }
  };
  return (
    <Modal
      className={`modal-program manager-program-modal modal-lg ${theme.className} ${rtl.direction}-support`}
      isOpen={isOpen}
      toggle={toggle}
    >
      <Form
        onSubmit={onSubmitForm}
        validate={(values) => formValidation.validateForm(values)}
        initialValues={data}
      >
        {({ handleSubmit, form, submitting, pristine, values }) => (
          <form className="form" onSubmit={handleSubmit}>
            <ModalHeader tag="div" className="custom-title w100">
              <div className="d-flex justify-content-between align-items-center w-100">
                <h3>Engagement</h3>
                <ButtonToolbar className="modal__footer flex justify-content-right w100">
                  <Button
                    outline
                    color="primary"
                    className="mr-3"
                    onClick={toggle}
                  >
                    Close
                  </Button>{" "}
                  <Button
                    type="submit"
                    disabled={loading}
                    className="btn btn-primary"
                    color="#ffffff"
                  >
                    Save
                  </Button>
                </ButtonToolbar>
              </div>  
            </ModalHeader>
            <ModalBody className="modal-lg">
              {
                !data.parent_id && <><Row>
                  <Col><h4 className="padding-10">Approvals and Budget: </h4></Col>
                </Row>
                  <Row>
                    <Col md="4" lg="4" xl="4">
                      <div className="d-flex">
                        
                        <CheckboxField
                          name="use_budget_cascading"
                          label="Use budget cascading"
                          checked={data.use_budget_cascading}
                          onChange={() => {
                            data.use_budget_cascading = !data.use_budget_cascading;
                          }}
                        />
                        <TooltipPopup
                          openTooltipPopup={openTooltipPopup}
                          handleCloseTooltipPopup={handleCloseTooltipPopup}
                          handleOpenTooltipPopup={() =>
                            handleOpenTooltipPopup("use_budget_cascading")
                          }
                          title="use_budget_cascading"
                          text={BUDGET_INFO_POPUP_DATA.budgetCascadingInfoTitle}
                        >
                          <span className="ml-2">
                            <HelpOutlineIcon fontSize="small" />
                          </span>
                        </TooltipPopup>
                      </div>
                    </Col>
                    <Col md="4" lg="4" xl="4">
                      <div className="d-flex">
                        <CheckboxField
                          name="budget_summary"
                          label="Enable budget summary"
                          checked={data.budget_summary}
                          onChange={() => {
                            data.budget_summary = !data.budget_summary;
                          }}
                        />
                        <TooltipPopup
                          openTooltipPopup={openTooltipPopup}
                          handleCloseTooltipPopup={handleCloseTooltipPopup}
                          handleOpenTooltipPopup={() =>
                            handleOpenTooltipPopup("budget_summary")
                          }
                          title="budget_summary"
                          text={BUDGET_INFO_POPUP_DATA.budgetSummaryInfoTitle}
                        >
                          <span className="ml-2">
                            <HelpOutlineIcon fontSize="small" />
                          </span>
                        </TooltipPopup>
                      </div>
                    </Col>
                    <Col md="4" lg="4" xl="4">
                      <div className="d-flex">
                        <CheckboxField
                          name="use_cascading_approvals"
                          label="Use Cascading Approvals"
                          checked={data.use_cascading_approvals}
                          onChange={() => {
                            data.use_cascading_approvals =
                              !data.use_cascading_approvals;
                          }}
                        />
                        <TooltipPopup
                          openTooltipPopup={openTooltipPopup}
                          handleCloseTooltipPopup={handleCloseTooltipPopup}
                          handleOpenTooltipPopup={() =>
                            handleOpenTooltipPopup("use_cascading_approvals")
                          }
                          title="use_cascading_approvals"
                          text={BUDGET_INFO_POPUP_DATA.cascadingApproval}
                        >
                          <span className="ml-2">
                            <HelpOutlineIcon fontSize="small" />
                          </span>
                        </TooltipPopup>
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="6" lg="4" xl="4">
                      <div className='d-flex'>
                        <CheckboxField
                          name="enable_schedule_awards"
                          label="Enable Schedule Awards"
                          checked={data.enable_schedule_awards}
                          onChange={() => { data.enable_schedule_awards = !data.enable_schedule_awards }}
                        />
                        <TooltipPopup openTooltipPopup={openTooltipPopup} handleCloseTooltipPopup={handleCloseTooltipPopup}
                          handleOpenTooltipPopup={() => handleOpenTooltipPopup("enable_schedule_awards")} title="enable_schedule_awards"
                          text={BUDGET_INFO_POPUP_DATA.scheduleDate}>
                          <span className="ml-2"><HelpOutlineIcon fontSize='small' /></span>
                        </TooltipPopup>
                      </div>
                    </Col>
                    <Col md="6" lg="4" xl="4">
                      <div className='d-flex'>
                        <CheckboxField
                          name="schedule_awards_required"
                          label="Schedule Awards Required"
                          checked={data.schedule_awards_required}
                          onChange={() => { data.schedule_awards_required = !data.schedule_awards_required }}
                        />
                        <TooltipPopup openTooltipPopup={openTooltipPopup} handleCloseTooltipPopup={handleCloseTooltipPopup}
                          handleOpenTooltipPopup={() => handleOpenTooltipPopup("schedule_awards_required")} title="schedule_awards_required"
                          text={BUDGET_INFO_POPUP_DATA.scheduleDate}>
                          <span className="ml-2"><HelpOutlineIcon fontSize='small' /></span>
                        </TooltipPopup>
                      </div>
                    </Col>
                  </Row></>
              }
              <Row>
                <Col>
                  <h4 className="padding-10">Social Wall: </h4>
                </Col>
              </Row>
              <Row>
                <Col md="6" lg="4" xl="4">
                  <div className="form__form-group">
                    <CheckboxField
                      name="uses_social_wall"
                      label="Enable Social Wall"
                      checked={data?.uses_social_wall}
                      onChange={() => {data.uses_social_wall = !data.uses_social_wall}}
                    />
                  </div>
                </Col>
                <Col md="6" lg="4" xl="4">
                  <div className="form__form-group">
                    <CheckboxField
                      name="allow_hierarchy_to_view_social_wall"
                      label="Other programs in this hierarchy can view this programs social wall"
                      checked={data?.allow_hierarchy_to_view_social_wall}
                      onChange={() => {data.allow_hierarchy_to_view_social_wall = !data.allow_hierarchy_to_view_social_wall}}
                    />
                  </div>
                </Col>
                <Col md="6" lg="4" xl="4">
                  <div className="form__form-group">
                    <CheckboxField
                      name="can_view_hierarchy_social_wall"
                      label="This program can view other programs social wall"
                      checked={data?.can_view_hierarchy_social_wall}
                      onChange={() => {data.can_view_hierarchy_social_wall = !data.can_view_hierarchy_social_wall}}
                    />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col md="6" lg="4" xl="4">
                  <div className="form__form-group">
                    <CheckboxField
                      name="managers_can_post_social_wall_messages"
                      label="Managers can post messages"
                      checked={data?.managers_can_post_social_wall_messages}
                      onChange={() => {data.managers_can_post_social_wall_messages = !data.managers_can_post_social_wall_messages}}
                    />
                  </div>
                </Col>
                <Col md="6" lg="4" xl="4">
                  <div className="form__form-group">
                    <CheckboxField
                      name="social_wall_separation"
                      label="Allow participants to view the social wall of any program he is not currently logged into"
                      checked={data?.social_wall_separation}
                      onChange={() => {data.social_wall_separation = !data.social_wall_separation}}
                    />
                  </div>
                </Col>
                <Col md="6" lg="4" xl="4">
                  <div className="form__form-group">
                    <CheckboxField
                      name="remove_social_from_pending_deactivation"
                      label="Remove Social From Pending Deactivation View"
                      checked={data?.remove_social_from_pending_deactivation}
                      onChange={() => {data.remove_social_from_pending_deactivation = !data.remove_social_from_pending_deactivation}}
                    />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <h4 className="padding-10">Leaderboards: </h4>
                </Col>
              </Row>
              <Row>
                <Col md="6" lg="4" xl="4">
                  <div className="form__form-group">
                    <CheckboxField
                      name="uses_leaderboards"
                      label="Enable Leaderboards"
                      checked={data?.uses_leaderboards}
                      onChange={() => {data.uses_leaderboards = !data.uses_leaderboards}}
                    />
                  </div>
                </Col>
                <Col md="6" lg="4" xl="4">
                  <div className="form__form-group">
                    <CheckboxField
                      name="allow_view_leaderboards_not_logged_into"
                      label="Allow participants to view leaderboards of any program he is not currently logged into"
                      checked={data?.leaderboard_seperation}
                      onChange={() => {data.leaderboard_seperation = !data.leaderboard_seperation}}
                    />
                  </div>
                </Col>
                <Col md="6" lg="4" xl="4">
                  <div className="form__form-group">
                    <CheckboxField
                      name="share_siblings_leader_board"
                      label="Share sibling leaderboards"
                      checked={data?.share_siblings_leader_board}
                      onChange={() => {data.share_siblings_leader_board = !data.share_siblings_leader_board}}
                    />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col md="6" lg="4" xl="4">
                  <div className="form__form-group">
                    <CheckboxField
                      name="use_one_leaderboard"
                      label="Use one leaderboard"
                      checked={data?.use_one_leaderboard}
                      onChange={() => {data.use_one_leaderboard = !data.use_one_leaderboard}}
                    />
                  </div>
                </Col>
              </Row>

              <Row>
                <Col>
                  <h4 className="padding-10">Peer to Peer: </h4>
                </Col>
              </Row>
              <Row>
                <Col md="6" lg="4" xl="4">
                  <div className="form__form-group">
                    <CheckboxField
                      name="uses_peer2peer"
                      checked={data?.uses_peer2peer}
                      label="Enable Peer to Peer"
                      onChange={() => {data.uses_peer2peer = !data.uses_peer2peer}}
                    />
                  </div>
                </Col>
                <Col md="6" lg="4" xl="4">
                  <div className="form__form-group">
                    <CheckboxField
                      name="allow_award_peers_not_logged_into"
                      label="Allow participants to award peers in any program he is not currently logged into"
                      checked={data?.allow_award_peers_not_logged_into}
                      onChange={() => {data.allow_award_peers_not_logged_into = !data.allow_award_peers_not_logged_into}}
                    />
                  </div>
                </Col>
                <Col md="6" lg="4" xl="4">
                  <div className="form__form-group">
                    <CheckboxField
                      name="allow_search_peers_not_logged_into"
                      label="Allow participants to search for peers in any program he is not currently logged into"
                      checked={data?.allow_search_peers_not_logged_into}
                      onChange={() => {data.allow_search_peers_not_logged_into = !data.allow_search_peers_not_logged_into}}
                    />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col md="6" lg="4" xl="4">
                  <div className="form__form-group">
                    <CheckboxField
                      name="uses_hierarchy_peer2peer"
                      label="Use hierarchy peer 2 peer"
                      checked={data?.uses_hierarchy_peer2peer}
                      onChange={() => {data.uses_hierarchy_peer2peer = !data.uses_hierarchy_peer2peer}}
                    />
                  </div>
                </Col>
                <Col md="6" lg="4" xl="4">
                  <div className="form__form-group">
                    <CheckboxField
                      name="share_siblings_peer2peer"
                      label="Share sibling's peer to peer"
                      checked={data?.share_siblings_peer2peer}
                      onChange={() => {data.share_siblings_peer2peer = !data.share_siblings_peer2peer}}
                    />
                  </div>
                </Col>
              </Row>

              <Row>
                <Col>
                  <h4 className="padding-10">Goals: </h4>
                </Col>
              </Row>
              <Row>
                <Col md="6" lg="4" xl="4">
                  <div className="form__form-group">
                    <CheckboxField
                      name="uses_goal_tracker"
                      label="Enable goal tracker"
                      checked={data?.uses_goal_tracker}
                      onChange={() => {data.uses_goal_tracker = !data.uses_goal_tracker}}
                    />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <h4 className="padding-10">Other: </h4>
                </Col>
              </Row>
              <Row>
                    <Col sm="6" md="6" lg="4" xl="4">
                      <div className="form__form-group">
                        <CheckboxField 
                          name="uses_units" 
                          label="Uses units" 
                          checked={data?.uses_units}
                          onChange={() => {data.uses_units = !data.uses_units}}
                        />
                      </div>
                      <div className="form__form-group">
                        <CheckboxField
                          name="allow_multiple_participants_per_unit"
                          label="Allow multiple participants per unit"
                          checked={data?.allow_multiple_participants_per_unit}
                          onChange={() => {data.allow_multiple_participants_per_unit = !data.allow_multiple_participants_per_unit}}
                        />
                      </div>
                    </Col>
                    <Col sm="6" md="6" lg="4" xl="4">
                      <div className="form__form-group">
                        <CheckboxField
                          name="enable_how_are_you_feeling"
                          label="How are you feeling"
                          checked={data?.enable_how_are_you_feeling}
                          onChange={() => {data.enable_how_are_you_feeling = !data.enable_how_are_you_feeling}}
                        />
                      </div>
                      <div className="form__form-group">
                        <CheckboxField
                          name="enable_referrals"
                          label="Referrals"
                          checked={data?.enable_referrals}
                          onChange={() => {data.enable_referrals = !data.enable_referrals}}
                        />
                      </div>
                    </Col>
                    <Col sm="6" md="4" lg="4" xl="4">
                      <div className="form__form-group">
                        <CheckboxField
                          name="allow_milestone_award"
                          label="Allow Milestone Awards"
                          checked={data?.allow_milestone_award}
                          onChange={() => {data.allow_milestone_award = !data.allow_milestone_award}}
                        />
                      </div>
                      <div className="form__form-group">
                        <CheckboxField
                          name="allow_third_party"
                          label="Third Party (HMI)"
                          checked={data?.allow_third_party}
                          onChange={() => {data.allow_third_party = !data.allow_third_party}}
                        />
                      </div>
                    </Col>
                    <Col sm="6" md="4" lg="4" xl="4">
                      <div className="form__form-group">
                        <CheckboxField
                          name="allow_award_new_participant"
                          label="Award new participant"
                          checked={data?.allow_award_new_participant}
                          onChange={() => {data.allow_award_new_participant = !data.allow_award_new_participant}}
                        />
                      </div>
                      <div className="form__form-group">
                        <CheckboxField
                          name="allow_save_to_hierarchy"
                          label="Allow Save to Hierarchy"
                          checked={data?.allow_save_to_hierarchy}
                          onChange={() => {data.allow_save_to_hierarchy = !data.allow_save_to_hierarchy}}
                        />
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <h4 className="padding-10">Entrata: </h4>
                    </Col>
                  </Row>
                  <Row>
                        <Col sm="6" md="6" lg="4" xl="4">
                          <div className="form__form-group">
                            <CheckboxField
                              name="uses_entrata_pending_approvals"
                              label="Enable Entrata Pending Approvals"
                              checked={data?.uses_entrata_pending_approvals}
                              onChange={() => {data.uses_entrata_pending_approvals = !data.uses_entrata_pending_approvals}}
                            />
                          </div>
                        </Col>
                  </Row>
                  <br/>
                  <br/>
            </ModalBody>
          </form>
        )}
      </Form>
    </Modal>
  );
};

EngagementModal.propTypes = {
  theme: ThemeProps.isRequired,
  rtl: RTLProps.isRequired,
  data: Object.isRequired,
};

export default (
  connect((state) => ({
    theme: state.theme,
    rtl: state.rtl,
    data: state.program,
  }))(EngagementModal)
);
